/** @format */

import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { locales } from "./init";

/**
 * A component that outputs a widget for language switching.
 *
 * It either outputs a list of links, if the changeURI prop is true, or a list of buttons if false.
 *
 * The links don't change the language directly, they link to the same page in a different language, changing
 * the first part of the URL e.g. from /en/ to /cy/. The LocaleWrapper then sets the language.
 *
 * The buttons on the other hand change the language directly, without changing the URL.
 */
interface LocaleSwitchProps {
  className?: string;
}

const LocaleSwitch: React.FC<LocaleSwitchProps> = ({ className }) => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  const switchLocaleInURI = (URI: string, newLocale: string): string => {
    return URI.replace(new RegExp(`^/(?:en|cy)`), `/${newLocale}`);
  };

  return (
    <ul
      className={`navbar-nav nav LocaleSwitch${
        className ? ` ${className}` : ""
      }`}
    >
      {locales.map(
        (locale) =>
          i18n.resolvedLanguage !== locale && (
            <li key={locale} className="nav-item">
              <Link
                to={switchLocaleInURI(pathname, locale)}
                key={locale}
                className="d-inline-block border-0 px-2 px-sm-3"
              >
                <Button className="localeButtonFix" variant="light">
                  {i18n.getFixedT(locale)("localeName")}
                </Button>
              </Link>
            </li>
          ),
      )}
    </ul>
  );
};

export default LocaleSwitch;
